module.exports = __webpack_public_path__ + "img/france-pneumonia-male.efef9f6f.png";